import React, { useEffect, useRef } from 'react';
import QRCodeStyling from 'qr-code-styling';

export const QR_STYLES = [
  {
    id: 'classic',
    name: 'Classic Red',
    desc: 'Rounded dots, red corners',
    dotsType: 'rounded',
    cornersSquareType: 'extra-rounded',
    cornersDotType: 'dot',
    dotsColor: '#111111',
    cornersColor: '#E8001D',
  },
  {
    id: 'dots',
    name: 'Pure Dots',
    desc: 'Circle dots, black corners',
    dotsType: 'dots',
    cornersSquareType: 'dot',
    cornersDotType: 'dot',
    dotsColor: '#222222',
    cornersColor: '#111111',
  },
  {
    id: 'sharp',
    name: 'Sharp Edge',
    desc: 'Square dots, red frame',
    dotsType: 'square',
    cornersSquareType: 'square',
    cornersDotType: 'square',
    dotsColor: '#111111',
    cornersColor: '#E8001D',
  },
  {
    id: 'elegant',
    name: 'Gold Elegant',
    desc: 'Rounded dots, gold accents',
    dotsType: 'rounded',
    cornersSquareType: 'extra-rounded',
    cornersDotType: 'dot',
    dotsColor: '#1a1a1a',
    cornersColor: '#FFFFFF',
  },
];

function StyledQR({ value, size = 200, styleId = 'classic' }) {
  const ref = useRef(null);
  const qrCode = useRef(null);

  const qrStyle = QR_STYLES.find((s) => s.id === styleId) || QR_STYLES[0];

  useEffect(() => {
    if (ref.current) {
      ref.current.innerHTML = '';
    }

    qrCode.current = new QRCodeStyling({
      width: size,
      height: size,
      type: 'svg',
      data: value,
      dotsOptions: {
        color: qrStyle.dotsColor,
        type: qrStyle.dotsType,
      },
      cornersSquareOptions: {
        color: qrStyle.cornersColor,
        type: qrStyle.cornersSquareType,
      },
      cornersDotOptions: {
        color: qrStyle.cornersColor,
        type: qrStyle.cornersDotType,
      },
      backgroundOptions: {
        color: '#ffffff',
      },
      qrOptions: {
        errorCorrectionLevel: 'M',
      },
    });

    if (ref.current) {
      qrCode.current.append(ref.current);
    }
    // The individual `qrStyle.*` fields are derived from `styleId`, which IS a
    // dependency — so listing them adds nothing except a rebuild of the QR canvas
    // on every render, which visibly flickers the code.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, size, styleId]);

  return (
    <div style={{ display: 'inline-block' }}>
      <div ref={ref} style={{ borderRadius: qrStyle.dotsType === 'square' ? '4px' : '14px', overflow: 'hidden' }} />
    </div>
  );
}

export default StyledQR;
